/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { PntAppControllerGetScreenbugByDateQueryResponse, PntAppControllerGetScreenbugByDatePathParams, PntAppControllerGetScreenbugByDateQueryParams } from "../models/PntAppControllerGetScreenbugByDate";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { pntAppControllerGetScreenbugByDate } from "../axios/pntAppControllerGetScreenbugByDate";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const pntAppControllerGetScreenbugByDateQueryKey = (slug: PntAppControllerGetScreenbugByDatePathParams["slug"], params: PntAppControllerGetScreenbugByDateQueryParams) => ["api-v2", { url: '/pnt/v2/segments/:slug/screenbug', params: {slug:slug} }, ...(params ? [params] : [])] as const

export type PntAppControllerGetScreenbugByDateQueryKey = ReturnType<typeof pntAppControllerGetScreenbugByDateQueryKey>

export function pntAppControllerGetScreenbugByDateQueryOptions(slug: PntAppControllerGetScreenbugByDatePathParams["slug"], params: PntAppControllerGetScreenbugByDateQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = pntAppControllerGetScreenbugByDateQueryKey(slug, params)
        return queryOptions<PntAppControllerGetScreenbugByDateQueryResponse, ResponseErrorConfig<Error>, PntAppControllerGetScreenbugByDateQueryResponse, typeof queryKey>({
         enabled: !!(slug&& params),
         queryKey,
         queryFn: async ({ signal }) => {
            return pntAppControllerGetScreenbugByDate(slug, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Retrieve the screenbugs for a given time range
 * {@link /pnt/v2/segments/:slug/screenbug}
 */
export function usePntAppControllerGetScreenbugByDate<TData = PntAppControllerGetScreenbugByDateQueryResponse, TQueryData = PntAppControllerGetScreenbugByDateQueryResponse, TQueryKey extends QueryKey = PntAppControllerGetScreenbugByDateQueryKey>(slug: PntAppControllerGetScreenbugByDatePathParams["slug"], params: PntAppControllerGetScreenbugByDateQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<PntAppControllerGetScreenbugByDateQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? pntAppControllerGetScreenbugByDateQueryKey(slug, params)
         

         const query = useQuery({
          ...pntAppControllerGetScreenbugByDateQueryOptions(slug, params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}